import Vue from 'vue';
import Vuex from 'vuex';
import publicModule from './modules/public.js';
import apiModule from './modules/api.js';
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    publicModule,
	apiModule
  },
});
export default store;
